import type { StaticImageData } from 'next/image';
import CoverPhotoPlaceholder1 from 'public/img/illustrations/tlv-photo-placeholders/house1.svg';
import CoverPhotoPlaceholder2 from 'public/img/illustrations/tlv-photo-placeholders/house2.svg';
import CoverPhotoPlaceholder3 from 'public/img/illustrations/tlv-photo-placeholders/house3.svg';
import CoverPhotoPlaceholder4 from 'public/img/illustrations/tlv-photo-placeholders/house4.svg';
import CoverPhotoPlaceholder5 from 'public/img/illustrations/tlv-photo-placeholders/house5.svg';
import CoverPhotoPlaceholder6 from 'public/img/illustrations/tlv-photo-placeholders/house6.svg';

const placeholderImages = [
  CoverPhotoPlaceholder1,
  CoverPhotoPlaceholder2,
  CoverPhotoPlaceholder3,
  CoverPhotoPlaceholder4,
  CoverPhotoPlaceholder5,
  CoverPhotoPlaceholder6,
] as StaticImageData[];

function generateNumericHash(str: string) {
  let hash = 5381;
  let i = str.length;
  while (i) {
    // biome-ignore lint/suspicious/noBitwiseOperators: Preserve existing functionality
    // biome-ignore lint/nursery/noIncrementDecrement: Preserve existing functionality
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  // biome-ignore lint/suspicious/noBitwiseOperators: Preserve existing functionality
  return hash >>> 0;
}

/**
 * Returns a stable placeholder image based on a hash of the given ID.
 * Prevents the placeholder from changing on page load or re-renders.
 */
export function getPlaceholderImage(id: string): StaticImageData {
  const hashedId = generateNumericHash(id);
  return placeholderImages[hashedId % placeholderImages.length];
}
